import React, { Component } from 'react'
import { observer } from 'mobx-react'
import EmailsStore from '../../stores/EmailsStore'
import { Grid, Header, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import LoadingWrapper from '../../components/LoadingWrapper'

@observer
class EmailsScreen extends Component {
  constructor (props) {
    super(props)
    this.emailsStore = new EmailsStore()
    window.document.title = 'Gestion des courriels'
  }

  componentDidMount () {
    this.emailsStore.loadAll()
  }

  componentWillUnmount () {
    this.emailsStore = null
  }

  render () {
    const { emails, isLoading } = this.emailsStore
    return (
      <>
        <Header as='h2'>Gestion des courriels</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Grid.Row>
          <Grid.Column>
            {!!emails.length &&
              <Table celled>
                <Table.Header key='header'>
                  <Table.Row>
                    <Table.HeaderCell>Code</Table.HeaderCell>
                    <Table.HeaderCell>Titre</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body key='body'>
                  {emails.map(email => {
                    return (
                      <Table.Row key={`email_${email.code}`}>
                        <Table.Cell>
                          <Link to={`/emails/edit/${email.code}`}>{email.code}</Link>
                        </Table.Cell>
                        <Table.Cell>
                          {email.title}
                        </Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table>}
          </Grid.Column>
        </Grid.Row>

      </>
    )
  }
}

EmailsScreen.propTypes = {}

export default EmailsScreen
